import { Button, CircularProgress, Stack } from "@mui/joy"

function Botao (props) {
    
    var onClick = props.onClick
    var color = props.color
    var size = props.size
    var text = props.text
    var loading = props.loading
    var hidden = props.hidden

    if(hidden) {
        return ""
    }

    if(loading) {
        return <Button color="neutral" disabled={true} size={size}>
        <Stack direction={"row"} spacing={2} sx={{
            flexDirection: "row",
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center"
        }}>
            <CircularProgress color="danger" size={"sm"} />
            {/* {text} */}
        </Stack>
    </Button>
    }

    return <Button color={color} onClick={onClick} size={size}>
        {text}
    </Button>

}

export default Botao